(() => {
  const cardSelector = '.rebuy-bundle-builder__step-product';
  const triggerSelector = `
    .rebuy-product-image.clickable a,
    .rebuy-product-title.clickable a,
    .rebuy-product-image.clickable,
    .rebuy-product-title.clickable
  `;
  const quickViewSelector = '.rebuy-bundle-builder__product-quick-view';

  function openQuickView(card) {
    const btn = card.querySelector(quickViewSelector);
    if (btn) btn.click();
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(`${cardSelector} ${triggerSelector}`);
      if (!trigger) return;

      const card = trigger.closest(cardSelector);
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openQuickView(card);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const trigger = event.target.closest(`${cardSelector} ${triggerSelector}`);
      if (!trigger) return;

      const card = trigger.closest(cardSelector);
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openQuickView(card);
    },
    true
  );
})();










(() => {
  const stepSelector = '.rebuy-bundle-builder__step-container';
  const headerSelector = '.rebuy-bundle-builder__step-header';
  const titleSelector = '.rebuy-bundle-builder__step-header-title';
  const toggleBtnSelector = '.rebuy-bundle-builder__step-header-collapse-button';

  function toggleStep(step) {
    const btn = step.querySelector(toggleBtnSelector);
    if (btn) btn.click();
  }

  document.addEventListener(
    'click',
    (e) => {
      const header = e.target.closest(`${headerSelector}, ${titleSelector}`);
      if (!header) return;

      const step = header.closest(stepSelector);
      if (!step) return;

      // prevent double firing when clicking actual button
      if (e.target.closest(toggleBtnSelector)) return;

      e.preventDefault();
      e.stopPropagation();

      toggleStep(step);
    },
    true
  );
})();





// savings keh niche price
(function () {
  const ROOT = '.tj-page-bundle-builder';
  const TOTAL_LINE_CLASS = 'rebuy-bundle-builder__custom-total-line';

  function ensureTotalLine() {
    const root = document.querySelector(ROOT);
    if (!root) return;

    const savingsEl = root.querySelector('.rebuy-bundle-builder__total-savings-container');
    const button = root.querySelector('.rebuy-bundle-builder__group-container-action .rebuy-button');
    const buttonMoneyWrap = root.querySelector('.rebuy-bundle-builder__group-container-action .rebuy-button .rebuy-money');
    const buttonMoney = root.querySelector(
      '.rebuy-bundle-builder__group-container-action .rebuy-button .rebuy-money.sale span:last-child'
    );

    let totalLine = root.querySelector('.' + TOTAL_LINE_CLASS);

    // ❌ If savings not present → remove custom total + restore button price
    if (!savingsEl) {
      if (totalLine) totalLine.remove();
      if (buttonMoneyWrap) buttonMoneyWrap.style.display = '';
      return;
    }

    // Continue only if required elements exist
    if (!button || !buttonMoney) return;

    const totalText = buttonMoney.textContent.trim();
    if (!totalText) return;

    if (!totalLine) {
      totalLine = document.createElement('div');
      totalLine.className = TOTAL_LINE_CLASS;
      savingsEl.insertAdjacentElement('afterend', totalLine);
    }

    totalLine.innerHTML = `
      <span class="rebuy-bundle-builder__custom-total-label">Bundle Price:</span>
      <span class="rebuy-bundle-builder__custom-total-amount">${totalText}</span>
    `;

    if (buttonMoneyWrap) buttonMoneyWrap.style.display = 'none';
  }

  let ticking = false;
  function scheduleUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ensureTotalLine();
      ticking = false;
    });
  }

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('DOMContentLoaded', scheduleUpdate);
  window.addEventListener('load', scheduleUpdate);

  // fallback
  setInterval(scheduleUpdate, 1000);
})();